"use strict";
import m from 'mithril';

export default function (container, production, siteName, view) {
    const data = {
        submit: e => {
            e.preventDefault();

            m.request(
                {
                    body: {
                        password: data.password,
                        username: data.username
                    },
                    method: 'POST',
                    url: `${production ? 'https://auth.northpointfleetmanagement.com.au' : 'http://auth.n.l'}/login`,
                    withCredentials: true
                }
            )
                .then(_ => {
                    let urlSearchParams = new URLSearchParams(location.search);

                    location.href = urlSearchParams.get('p') ?? '/';

                })
                .catch(_ => data.post_message = 'Invalid username or password.');
        },
        password: '',
        production: production,
        siteName: siteName,
        username: ''
    };

    return {
        exec: () => m.mount(container, {view: () => m(view, data)})
    };
}